import React from "react";

import Tag from "antd/es/tag";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";
import Email from "@mapmycustomers/shared/types/email/Email";

import emailSendingSrc from "@app/assets/emailQueue/email-sending.svg";
import { formatRawDate } from "@app/util/formatters";

import styles from "./EmailStatus.module.scss";
import messages from "./messages";
import statusMessages from "./statusMessages";

interface EmailStatusTagProps {
  email: Email;
}

const EmailStatusTag = ({ email }: EmailStatusTagProps) => {
  const intl = useIntl();

  if (email.status === EmailStatus.CANCELLED) {
    return null;
  }

  const statusLabel = intl.formatMessage(statusMessages[email.status]);

  switch (email.status) {
    case EmailStatus.SENT: {
      return (
        <Tooltip
          title={intl.formatMessage(messages.sentTodayTooltip, {
            time: formatRawDate(email.date, "p"),
          })}
        >
          <Tag color="green">{statusLabel}</Tag>
        </Tooltip>
      );
    }
    case EmailStatus.SENDING:
      return (
        <div className={styles.sendingContainer}>
          <Tooltip title={intl.formatMessage(messages.sendingTooltip)}>
            <Tag color="geekblue">{statusLabel}</Tag>
          </Tooltip>
          <img alt="logo" src={emailSendingSrc} />
        </div>
      );
    case EmailStatus.SCHEDULED:
    case EmailStatus.SUBMITTED:
      return (
        <Tooltip title={statusLabel}>
          <Tag color="default">{statusLabel}</Tag>
        </Tooltip>
      );
    case EmailStatus.ERRORED:
      return (
        <Tooltip title={intl.formatMessage(messages.notSentTooltip)}>
          <Tag color="red">{statusLabel}</Tag>
        </Tooltip>
      );
  }
};

export default EmailStatusTag;
